<template>
  <div>
    {{filter.values.places.map(place=>place.label).join(', ')}} <b>({{filter.values.type}})</b>
  </div>
</template>
<script>
  export default {
    props: {
      filter: Object
    },
    name: 'placeParams'
  }
</script>
<style>
</style>
